
export default {
  name: "app-termos",
  data() {
    return {};
  },
};
